(function() {
    'use strict';

function expandDetails($compile) {
    return {
        scope: true,
        restrict: 'C',
        link: function(scope, element, attrs) {

            scope.expanded = false;

            var onlyMobileClass = ' d-block d-md-none';
            if(element.hasClass('details-collapsed')){
                onlyMobileClass = '';
            }

            element
                .wrap('<div style="position:relative"></div>')
                .after($compile( [
                    '<div class="expand-details-link clearfix'+onlyMobileClass+'">',
                        '<a href="javascript:void(0);" ng-click="toggleDetails();" title="Expand/collapse details">',
                            '<i ng-show="!expanded" class="btn-collapse glyphicon glyphicon-chevron-down" ></i>',
                            '<i ng-show="expanded"  class="btn-collapse glyphicon glyphicon-chevron-up"></i>',
                        '</a>',
                    '</div>'].join("") )(scope));

            var parentElement = element.closest('li.item'); // this is for Orders listing

            scope.toggleDetails = function(){
                if(!scope.expanded){
                    element
                        .removeClass('details-collapsed')
                        .addClass('details-expanded');
                    parentElement
                        .removeClass('details-collapsed-parent')
                        .addClass('details-expanded-parent');
                } else {
                    element
                        .removeClass('details-expanded')
                        .addClass('details-collapsed');
                    parentElement
                        .removeClass('details-expanded-parent')
                        .addClass('details-collapsed-parent');

                }
                scope.expanded = !scope.expanded;
            }


        }
    };
}
expandDetails.$inject = ['$compile'];
angular.module('app').directive('details', expandDetails);


}());